__turbopack_context__.v({
  "bottomSheet": "ProductCardM1-module__w-L9uq__bottomSheet",
  "m1spec": "ProductCardM1-module__w-L9uq__m1spec",
  "media": "ProductCardM1-module__w-L9uq__media",
  "root": "ProductCardM1-module__w-L9uq__root",
});
